$(function() {
    $.fn.equalize=function(measureID,apply) {
        var apply=(apply=='')?measureID:apply;
        $(measureID).each(function(){
            var _containers=[];
            $(apply,this).each(function(){
                $(this).css('height','inherit');
                _containers.push($(this).outerHeight());
            });
            var max=Math.max.apply(null,_containers);
            $(apply,this).each(function(){
                $(this).css('height',max+'px');
            });
        });
    return this;

    }

    if ($(window).width() > 767) {
        setTimeout(function(){$(document).equalize(".js-equal-container",".js-equal-unit");},600);
        setTimeout(function(){$(document).equalize(".js-equal-container",".js-equal-unit-secondary");},300);
        setTimeout(function(){$(document).equalize(".js-equal-container",".js-equal-unit-tertiary");},300);
    }
});